
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { CustomerNotificationSettingsDto_$reflection, CustomerNotificationSetting_$reflection } from "../../../Shared/NotificationSettings.js";
import { union_type, class_type, string_type, record_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../../Shared/Shared.js";

export class State extends Record {
    constructor(Settings, FormState) {
        super();
        this.Settings = Settings;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Notifications.Types.State", [], State, () => [["Settings", RequestedValue$1_$reflection(list_type(CustomerNotificationSetting_$reflection()))], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SettingsFetched", "ChangeSetting", "SaveSettings", "SettingsSaved", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Notifications.Types.Msg", [], Msg, () => [[["Item", CustomerNotificationSettingsDto_$reflection()]], [["Item", CustomerNotificationSetting_$reflection()]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

